import { Component, Input } from '@angular/core';

@Component({
  selector: 'rap-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() showSpinner: boolean = true;
}
